var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembersNumber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_80_14",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 39,
    height: 39
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "#C32327"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_80_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.625 32.5V27.95C1.625 27.0292 1.86198 26.1828 2.33594 25.4109C2.8099 24.6391 3.43958 24.05 4.225 23.6438C5.90417 22.8042 7.61042 22.1745 9.34375 21.7547C11.0771 21.3349 12.8375 21.125 14.625 21.125C16.4125 21.125 18.1729 21.3349 19.9062 21.7547C21.6396 22.1745 23.3458 22.8042 25.025 23.6438C25.8104 24.05 26.4401 24.6391 26.9141 25.4109C27.388 26.1828 27.625 27.0292 27.625 27.95V32.5H1.625ZM30.875 32.5V27.625C30.875 26.4333 30.5432 25.2891 29.8797 24.1922C29.2161 23.0953 28.275 22.1542 27.0563 21.3688C28.4375 21.5313 29.7375 21.8089 30.9563 22.2016C32.175 22.5943 33.3125 23.075 34.3687 23.6438C35.3438 24.1854 36.0885 24.788 36.6031 25.4516C37.1177 26.1151 37.375 26.8396 37.375 27.625V32.5H30.875ZM14.625 19.5C12.8375 19.5 11.3073 18.8635 10.0344 17.5906C8.76146 16.3177 8.125 14.7875 8.125 13C8.125 11.2125 8.76146 9.68229 10.0344 8.40938C11.3073 7.13646 12.8375 6.5 14.625 6.5C16.4125 6.5 17.9427 7.13646 19.2156 8.40938C20.4885 9.68229 21.125 11.2125 21.125 13C21.125 14.7875 20.4885 16.3177 19.2156 17.5906C17.9427 18.8635 16.4125 19.5 14.625 19.5ZM30.875 13C30.875 14.7875 30.2385 16.3177 28.9656 17.5906C27.6927 18.8635 26.1625 19.5 24.375 19.5C24.0771 19.5 23.6979 19.4661 23.2375 19.3984C22.7771 19.3307 22.3979 19.2563 22.1 19.175C22.8313 18.3083 23.3932 17.3469 23.7859 16.2906C24.1786 15.2344 24.375 14.1375 24.375 13C24.375 11.8625 24.1786 10.7656 23.7859 9.70938C23.3932 8.65313 22.8313 7.69167 22.1 6.825C22.4792 6.68958 22.8583 6.60156 23.2375 6.56094C23.6167 6.52031 23.9958 6.5 24.375 6.5C26.1625 6.5 27.6927 7.13646 28.9656 8.40938C30.2385 9.68229 30.875 11.2125 30.875 13Z",
    fill: "#C32327"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersNumber);
export default __webpack_public_path__ + "static/media/MembersNumber.1a64924390ab9f8194e7f216a7d719ce.svg";
export { ForwardRef as ReactComponent };